import { motion } from "framer-motion";
import type { AuthLogoProps } from "../auth.types";

export const AuthLogo = ({
  src,
  alt = "Logo",
  includeLineBottom = true,
}: AuthLogoProps) => {
  return (
    <motion.div
      className="flex flex-col gap-3"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <img src={src} alt={alt} className="w-[212px] h-[75px] object-contain" />
      {includeLineBottom && (
        <div className="relative h-[1px] w-[255px]">
          <div className="absolute inset-0 bg-gradient-to-r from-[#1a6bff] to-transparent" />
          <motion.div
            className="absolute -left-2 top-1/2 -translate-y-1/2 h-[14px] w-[14px] rotate-45  rounded-sm border border-[#0C7EE7] bg-gradient-to-b from-[#0C7EE7] to-[#0C7EE7]/80"
            animate={{
              boxShadow: [
                "0 0 4px #1a6bff",
                "0 0 10px #1a6bff",
                "0 0 4px #1a6bff",
              ],
            }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          />
        </div>
      )}
    </motion.div>
  );
};
